import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { SearchBoxMixin } from '../../mixins/components/SearchBoxMixin';
import { AdornedInput } from '../AdornedInput/AdornedInput';
import { Adornment } from '../Adornment/Adornment';
import { IconSearch } from '../Icon/index';

/**
 * @extends AdornedInput
 * @since 6.4.0
 */
var SearchBox = /*#__PURE__*/styled(AdornedInput).withConfig({
  displayName: "SearchBox",
  componentId: "c11n-8-111-1__sc-6uapbf-0"
})(["", ""], SearchBoxMixin);
SearchBox.displayName = 'SearchBox';
SearchBox.propTypes = {
  /**
   * The `Adornment` for the `SearchBox`. Defaults to a search `Icon`.
   */
  rightAdornment: PropTypes.node
};
SearchBox.defaultProps = {
  rightAdornment: /*#__PURE__*/React.createElement(Adornment, null, /*#__PURE__*/React.createElement(IconSearch, null))
};

/** @component */
export { SearchBox };